import {ShippingRate} from './ShippingRate';
require('select2');
const queryString = require('query-string');
const templateSuppliersOnCategoryPage = require('pug-loader!../../../views/category/supplier-grid.pug');
const smoothScroll = require('smoothscroll');
const CustomEvents = require('./CustomEvents');

var s;
var app = {
  settings: {},

  init: function() {
    this.bindUIElements();
    this.bindUIEvents();

    CustomEvents.bindEvents();

    //on page init
    $(window).trigger('initQuantityInputs');
    $(window).trigger('initShoplistsQuantityInputs');
  },
  bindUIElements: function() {
    var t = this;
    /**
     * add new address button bind
     */
    if (jQuery('.newBillingAddressTrigger').length > 0) {
      var SettingsCtrl = require('./pages/settingsPage.js').init();
    }

    /**
     * onclick search results
     */
    var url = window.location.search;
    url = url.replace(/&?((page)|(pg))=([^&]$|[^&]*)/i, ''); //remove page or pg
    var queryString = url.substring(url.indexOf('?') + 1);
    queryString = queryString == '' ? queryString : queryString + '&';
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : sParameterName[1];
        }
      }
    };

    /**
     * init pagination suppliers page
     */
    if (jQuery('.pagination-suppliers-category').length > 0) {
      t.initPaginationSuppliersCategoryPage(false);
    }

    /**
     * Product Page Grid Init
     */
    $('a.grid-item:not(.grid-item-supplier)').on('click', function(ev) {
      ev.preventDefault();

      $('.grid-item-preview').hasClass('expanded')
        ? $('.grid-item-preview').slideUp('slow', function() {
            $(this).remove();
          })
        : null;

      var html = "<div id='quick-product-view' class='grid-item-preview'>xxcvxcv</div>";

      var selector = Math.floor($(this).index() / 5);

      $('a.grid-item')
        .eq((selector + 1) * 5 - 1)
        .after(html);
      $('.grid-item-preview').slideDown('slow', function() {
        $(this).addClass('expanded');
      });
    });

    /**
     * scroll-to function
     */
    $('.scroll-to').click(function() {
      var scrollTo = $(this).attr('href');
      var offSet = 100;

      if (scrollTo) {
        $('html, body').animate(
          {
            scrollTop: $(scrollTo).offset().top - offSet
          },
          600
        );
      }

      return false;
    });

    /**
     * init select for checkout process
     */
    if ($('#select-billing').length) {
      $('#select-billing').select2({
        data: $.map(window.billingData, function(obj) {
          obj.id = obj.id || obj.billing_id;
          obj.text = obj.text || obj.billing_address_name;
          return obj;
        }),
        minimumResultsForSearch: Infinity,
        escapeMarkup: function(markup) {
          console.log(markup);
          return markup;
        },
        templateResult: formatAddress, // omitted for brevity, see the source of this page
        templateSelection: formatRepoSelection // omitted for brevity, see the source of this page
      });

      function formatAddress(item) {
        if (item.loading) return item.text;

        var markup =
          "<div class='select2-result-repository clearfix'>" +
          "<div class='select2-result-repository__meta'>" +
          "<div class='select2-result-repository__title'>" +
          item.billing_address_name +
          '</div>';

        // if (repo.description) {
        //     markup += "<div class='select2-result-repository__description'>" + repo.description + "</div>";
        // }

        markup +=
          "<div class='select2-result-repository__statistics'>" +
          "<div class='select2-result-repository__forks'>" +
          item.billing_address_1.concat(
            ' ',
            item.billing_address_2,
            ', ',
            item.billing_city,
            ', ',
            item.billing_zipcode,
            ', ',
            item.billing_country
          ) +
          '</div>' +
          "<div class='select2-result-repository__forks'>" +
          item.billing_registration_number +
          ' ' +
          item.billing_vat +
          '</div>' +
          "<div class='select2-result-repository__forks'>" +
          item.billing_phone +
          '</div>' +
          "<div class='select2-result-repository__forks'>" +
          item.billing_reference +
          '</div>' +
          '</div>' +
          '</div></div>';

        return markup;
      }

      function formatRepoSelection(item) {
        // console.log(item.billing_address_name);
        html = '';
        html += "<div class='select2-result-repository__title'>" + item.billing_address_name + '</div>';
        html +=
          "<div class=''>" +
          item.billing_address_1.concat(
            ' ',
            item.billing_address_2,
            ', ',
            item.billing_city,
            ', ',
            item.billing_zipcode,
            ', ',
            item.billing_country
          ) +
          '</div>';
        html +=
          "<div class='select2-result-repository__forks'>" +
          item.billing_registration_number +
          ' ' +
          item.billing_vat +
          '</div>';

        return html;
        return item.billing_address_name + '<br>' + 'vlad';
        return repo.full_name || repo.text;
      }
    }
  },

  bindUIEvents: function() {
    var _t = this;

    let loadingSpinnerToggle = function(element, action) {
      if (action == 'hide') {
        $(element).fadeOut(150);
      } else {
        $(element).fadeIn();
      }
    };

    if ($('.input-number').length) {
      $('.input-number').each(function() {
        _t.initQuantityInputEditor($(this));
      });
    }

    window.addEventListener('triggerShippingCostCalculation', function(e) {
      if ($('#checkoutShoppingList').length) {
        //start shipping calculator events
        const shipping = new ShippingRate($('#checkoutShoppingList').serialize());

        loadingSpinnerToggle('#loading-panel-checkout-shopping-list', 'show');

        shipping
          .getShippingResult()
          .then(data => {
            let shipping_cost = +data.shipping_cost.NegotiatedRateCharges.TotalCharge.MonetaryValue;
            let extra_services = +$('#extra-services-cost').text();
            let cart_subtotal = $('#order_estimate_wo_shipping').val();

            //update shipping cost
            $('#shipping-cost').text(parseFloat(shipping_cost).toFixed(2));
            $('#order_estimate_shipping').val(shipping_cost);

            //calculate total costs
            // var order_total_wo_shipping = $("#order_estimate_wo_shipping").val();

            var order_total = parseFloat(shipping_cost + +cart_subtotal + +extra_services).toFixed(2);
            $('#totalCosts').text(order_total);
            $('#order_total, #order_estimate_total').val(order_total);

            // $("#order_estimate_shipping").val(+data.shipping_cost.NegotiatedRateCharges.TotalCharge.MonetaryValue);
            loadingSpinnerToggle('#loading-panel-checkout-shopping-list', 'hide');

            return;
          })
          .catch(err => {
            console.log(err);
            loadingSpinnerToggle('#loading-panel-checkout-shopping-list', 'hide');
          });
      } else {
        //calculate shipping rate for cart checkout page

        let loadingSpinnerWrapper = '#loading-panel-checkout';
        loadingSpinnerToggle(loadingSpinnerWrapper, 'display');
        const shipping = new ShippingRate($('#cartOrderCheckout').serialize());

        shipping
          .getShippingResult()
          .then(data => {
            let shipping_cost = +data.shipping_cost.NegotiatedRateCharges.TotalCharge.MonetaryValue;
            let extra_services = +$('#extra-services-cost').text();
            let cart_subtotal = +$('#cart_subtotal_input').val();

            // console.log(data);
            // //update shipping cost
            //set shipping costs

            //calculate total costs
            var order_total = parseFloat(shipping_cost + extra_services + +cart_subtotal).toFixed(2);

            //fill fields
            $('#shipping-cost').text(parseFloat(shipping_cost).toFixed(2));
            $('#input_order_estimate_shipping').val(parseFloat(shipping_cost).toFixed(2));
            $('#totalCosts').text(order_total);
            $('#order_total').val(order_total);
            loadingSpinnerToggle(loadingSpinnerWrapper, 'hide');

            return;
          })
          .catch(err => {
            loadingSpinnerToggle(loadingSpinnerWrapper, 'hide');
          });
      }
    });
  },

  initQuantityInputEditor: function(el) {
    var min = el.attr('min') || false;
    var max = el.attr('max') || false;

    var els = {};

    els.dec = el.prev();
    els.inc = el.next();

    el.each(function() {
      init($(this));
    });

    function init(el) {
      els.dec.on('click', decrement);
      els.inc.on('click', increment);

      function decrement() {
        var value = el[0].value;
        value--;
        if (!min || value >= min) {
          el[0].value = value;
        }
      }

      function increment() {
        var value = el[0].value;
        value++;
        if (!max || value <= max) {
          el[0].value = value++;
        }
      }
    }
  },

  initPaginationSuppliersCategoryPage: function(pagenumber) {
    var that = this;
    pagenumber = pagenumber ? pagenumber : parseInt(queryString.parse(location.search).page);
    $('.pagination-suppliers-category').pagination({
      items: window.totalElements,
      itemsOnPage: 18,
      currentPage: pagenumber ? pagenumber : 1,
      cssStyle: 'light-theme',
      hrefTextPrefix: '?page=',
      selectOnClick: false,
      nextText: '<i class="fa-right-open-big"></i>',
      prevText: '<i class="fa-left-open-big"></i>',
      onPageClick: function(pageNumberOnClick, event) {
        $('#supplier-grid > *').css('opacity', '0.3');

        event.preventDefault();
        $.ajax({
          url: window.location.origin + window.location.pathname,
          data: {
            ajax: true,
            page: pageNumberOnClick
          }
        }).done(function(data) {
          let locals = {
            count: data.sub_category.count,
            sub_category: data.sub_category,
            pageNumber: data.pageNumber
          };
          var suppliersGrid = templateSuppliersOnCategoryPage(locals);
          $('#supplier-grid').html(suppliersGrid);
          that.updateUrl(pageNumberOnClick);
          that.initPaginationSuppliersCategoryPage();

          var productsGrid = document.querySelector('#supplier-grid');

          smoothScroll(productsGrid);
        });
      }
    });
  },

  updateUrl: function(pageNumber) {
    var that = this;
    var newUrlQuery = queryString.parse(location.search);
    newUrlQuery.page = pageNumber;

    if (history.pushState) {
      window.history.pushState(null, null, '?' + queryString.stringify(newUrlQuery));
    } else {
      document.location.href = '?' + queryString.stringify(newUrlQuery);
    }
  }
};

module.exports = app;



// WEBPACK FOOTER //
// ./public/src/js/Elicious.js